define('core/httpService',['require','ns'],function (require) {
	'use strict';

	var ns = require('ns');

	var setting = {};

	var HttpService = function () {

		setting = ns.config.get('httpService');
	};

	HttpService.prototype = {

		request: function (option) {

			var _option = option || {};

			var _dataType = _option.dataType || 'json';
			var _type = _option.type || 'GET';
			var _param = _option.param || {};
			var _url = _option.url || '';

			var _errorCallback = _option.error || function () { };
			var _successCallback = _option.success || function () { };

			$.ajax({
				cache: false,
				data: _param,
				dataType: _dataType,
				retryCount: 0,
				timeout: setting.timeoutPeriod,
				type: _type,
				url: _url,

				beforeSend: function (jqXhr, settings) {

					ns.logger.debug('HttpService', '[' + _url + ']: requested');
				},

				success: function (response) {

					var log = '[' + _url + ']: response => ' + ns.utils.jsonEncode(response);

					ns.logger.debug('HttpService', log);

					_successCallback(response);
				},

				error: function (jqXhr, textStatus, errorThrown) {

					if (textStatus === 'timeout') {

						this.retryCount++;

						if (this.retryCount <= setting.maxRetryLimit) {

							var log = '[' + _url + ']: timeout (' + this.retryCount + ')';
							
							ns.logger.debug('HttpService', log);

							setTimeout($.proxy(function () {

								$.ajax(this);

							}, this), setting.retryInterval);

							return;
						}
					}

					_errorCallback(jqXhr, textStatus, errorThrown);
				}
			});
		}
	};

	return HttpService;
});
